import { SET_LOADED } from "./types";

export const initialState = {
  loaded: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADED:
      return {
        ...state,
        loaded: true,
      };

    default:
      return state;
  }
}
